export const formMaxWidthValue = 550;
export const formControlAddonButtonWidthValue = 44;
